/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ day: NonNullable<unknown> }} Today_Day_RestInputs */

const en_us2_today_day_rest = /** @type {(inputs: Today_Day_RestInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.day} · Rest`)
};

const pt_br2_today_day_rest = /** @type {(inputs: Today_Day_RestInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.day} · Descanso`)
};

const es_419_today_day_rest = /** @type {(inputs: Today_Day_RestInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.day} · Descanso`)
};

const pt_pt2_today_day_rest = /** @type {(inputs: Today_Day_RestInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.day} · Descanso`)
};

const fr_fr2_today_day_rest = /** @type {(inputs: Today_Day_RestInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.day} · Repos`)
};

const de_de2_today_day_rest = /** @type {(inputs: Today_Day_RestInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.day} · Pause`)
};

const it_it2_today_day_rest = /** @type {(inputs: Today_Day_RestInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.day} · Riposo`)
};

/**
* | output |
* | --- |
* | "{day} · Rest" |
*
* @param {Today_Day_RestInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const today_day_rest = /** @type {((inputs: Today_Day_RestInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Today_Day_RestInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_today_day_rest(inputs)
	if (locale === "es-419") return es_419_today_day_rest(inputs)
	if (locale === "pt-PT") return pt_pt2_today_day_rest(inputs)
	if (locale === "fr-FR") return fr_fr2_today_day_rest(inputs)
	if (locale === "de-DE") return de_de2_today_day_rest(inputs)
	if (locale === "it-IT") return it_it2_today_day_rest(inputs)
	return en_us2_today_day_rest(inputs)
});
export { today_day_rest as "today.day_rest" }